// @ts-check
import { SHOW_MODAL, HIDE_MODAL } from 'shared/actions/UnboundModalActions';

export default function reducer(state = null, action) {
  switch (action.type) {
    case SHOW_MODAL:
      const { name, ...rest } = action;
      return {
        name,
        visible: true,
        ...rest,
      };
    case HIDE_MODAL:
      return Object.assign({}, state, { visible: false });
    default:
      return state;
  }
}
